<template>
  <div class="fetch-status" :class="{ 'is-error': Boolean(errorMessage) && !loading }">
    <v-progress-circular
      v-if="loading"
      indeterminate
      :size="spinnerSize"
      :width="spinnerWidth"
      color="primary"
    />
    <v-icon v-else-if="errorMessage" :size="spinnerSize" color="error">
      mdi-alert-circle-outline
    </v-icon>
    <p class="fetch-status-text">{{ errorMessage || message }}</p>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    loading?: boolean;
    message?: string;
    errorMessage?: string;
    spinnerSize?: number;
    spinnerWidth?: number;
  }>(),
  {
    loading: false,
    message: "",
    errorMessage: "",
    spinnerSize: 18,
    spinnerWidth: 2,
  },
);
</script>

<style scoped>
.fetch-status {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  margin: 0 auto;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  color: #475569;
}

.fetch-status.is-error {
  color: #b91c1c;
}

.fetch-status-text {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
}
</style>
